import { Stack } from '@mui/material';

import { CreateAuditOperation } from '@store/audits/audits-operation/audits-operation.model';
import CollectInformations from './container/CollectInformation';
import ContainerInformations from './container/ContainerInformations';
import PictureInformation from './container/PictureInformation';
import WasteInformations from './container/WasteInformations';

interface AuditContainerProps {
  isPreco?: boolean;
  auditOperation?: CreateAuditOperation;
  updateAuditOperation: <T extends keyof CreateAuditOperation>(
    field: T,
    value: CreateAuditOperation[T]
  ) => void;
  errors:any;
}

const AuditContainer = (props: AuditContainerProps) => {

  const {
    isPreco = false,
    auditOperation,
    updateAuditOperation,
      errors
  } = props;

  return (
    <>
      <Stack py="24px" pr="10px">
        <ContainerInformations errors={errors} isPreco={isPreco} auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} />
        <WasteInformations errors={errors} isPreco={isPreco} auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} />
        <CollectInformations auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} />
        <PictureInformation auditOperation={auditOperation} updateAuditOperation={updateAuditOperation} />
      </Stack>
    </>
  );
};

export default AuditContainer;
